document.addEventListener('DOMContentLoaded', function() {
    const detailsElements = document.querySelectorAll('details');
  
    detailsElements.forEach(detail => {
      detail.addEventListener('toggle', function(event) {
        if (detail.open) {
          smoothOpen(detail);
        } else {
          smoothClose(detail);
        }
      });
    });
  
    function smoothOpen(detail) {
      const content = detail.querySelector('.accordion__content');
      const contentHeight = content.scrollHeight;
  
      content.style.height = '0';
      content.style.transition = 'height 0.4s ease';
  
      requestAnimationFrame(() => {
        content.style.height = `${contentHeight}px`;
      });
  
      content.addEventListener('transitionend', function handler() {
        content.style.height = '';
        content.removeEventListener('transitionend', handler);
      });
    }
  
    function smoothClose(detail) {
      const content = detail.querySelector('.accordion__content');
      const contentHeight = content.scrollHeight;
  
      content.style.height = `${contentHeight}px`;
  
      requestAnimationFrame(() => {
        content.style.height = '0';
      });
  
      content.addEventListener('transitionend', function handler() {
        if (!detail.open) {
          content.style.height = '';
        }
        content.removeEventListener('transitionend', handler);
      });
    }
  });